import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Navbar from './components/NavBar';
import Specialization from './components/Specialization';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import Services from './components/Service';
import ContactUs from './components/ContactUs';


function App() {
  return (
    <div className="App">
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="About" element={<About/>}/>
        <Route path="Services" element={<Services/>}/>
        <Route path="ContactUs" element={<ContactUs/>}/>
        {/* <Route path="Blog" element={<Blog/>}/> */}
      </Routes>
    </div>
  );
}

export default App;
